import { store } from '../redux/store';

export enum LOCAL_STORAGE_KEY {
  currentClassroomToken = 'currentClassroomToken',
  currentStudentClassroomToken = 'currentStudentClassroomToken',
  lessonModuleKey = 'lessonModuleKey',
  classroomMode = 'classroomMode',
}

type LocalStorageKey = keyof typeof LOCAL_STORAGE_KEY;

export const userLocalStorageKey = (uid: string | undefined, key: LocalStorageKey) =>
  `${uid}-${key}`;

export const readUserLocalStorage = (uid: string | undefined, key: LocalStorageKey) =>
  localStorage.getItem(userLocalStorageKey(uid, key));

/**
 * @deprecated Reads state from global store! Use `readUserLocalStorage` instead. 
 */
export function __userLocalStorageKey(key: LOCAL_STORAGE_KEY) {
  const uid = store.getState().firebase.authUser?.firebaseUser?.uid;
  return userLocalStorageKey(uid, key);
}
